import request from '@/utils/request'

let ProductApi = {

    /*分类管理*/
    catList(data) {
        return request._post('/shop/product.category/index', data);
    },
    /*分类添加*/
    catAdd(data) {
        return request._post('/shop/product.category/add', data);
    },
    /*分类删除*/
    catDel(data) {
        return request._post('/shop/product.category/delete', data);
    },
    /*分类修改*/
    catEdit(data) {
        return request._post('/shop/product.category/edit', data);
    },

     /*标签管理*/
     labelList(data) {
        return request._post('/shop/product.label/index', data);
    },
    /*标签添加*/
    labelAdd(data) {
        return request._post('/shop/product.label/add', data);
    },
    /*标签删除*/
    labelDel(data) {
        return request._post('/shop/product.label/delete', data);
    },
    /*标签修改*/
    labelEdit(data) {
        return request._post('/shop/product.label/edit', data);
    },

    /*产品列表*/
    productList(data) {
        return request._post('/shop/product.product/index', data);
    },
        /*产品列表*/
    supplyList(data) {
        return request._post('/shop/product.product/supply', data);
    },
    /*产品选择列表*/
    chooseLists(data) {
        return request._post('/shop/data.product/lists', data);
    },

    /*标签选择列表*/
    chooseLabelLists(data) {
        return request._post('/shop/data.product/labelLists', data);
    },
    /*规格选择列表*/
    chooseSpec(data) {
        return request._post('/shop/data.product/spec', data);
    },
    /*新增产品*/
    addProduct(data) {
        return request._post('/shop/product.product/add', data);
    },
    /*产品基础数据*/
    getBaseData(data) {
        return request._get('/shop/product.product/add', data);
    },
    /*删除产品*/
    delProduct(data) {
        return request._post('/shop/product.product/delete', data);
    },
    /*删除产品*/
    editRemark(data) {
        return request._post('/shop/product.product/editRemark', data);
    },
    /*产品基础数据*/
    getEditData(data) {
        return request._get('/shop/product.product/edit', data);
    },
    /*新增产品*/
    editProduct(data) {
        return request._post('/shop/product.product/edit', data);
    },
    /*新增规格组*/
    addSpec(data) {
        return request._post('/shop/product.spec/addSpec', data);
    },
    /*新增规格值*/
    addSpecValue(data) {
        return request._post('/shop/product.spec/addSpecValue', data);
    },
    /*商品列表不带分页*/
    getList(data) {
        return request._post('/shop/data.product/lists', data);
    },
    /*商品列表不带分页*/
    getActiveProductList(data) {
        return request._post('/shop/plus.fans.product/lists', data);
    },
    /*商品评论列表*/
    getCommentList(data) {
        return request._post('/shop/product.comment/index', data);
    },
     /*添加虚拟评论*/
     addComment(data) {
        return request._post('/shop/product.comment/addComment', data);
    },
    /*获取评论详情*/
    getComment(data) {
        return request._post('/shop/product.comment/detail', data);
    },
    /*获取评论详情*/
    editComment(data) {
        return request._post('/shop/product.comment/edit', data);
    },
    /*删除评论*/
    delComment(data) {
        return request._post('/shop/product.comment/delete', data);
    },
    /*得到分类图片*/
    cateImage(data) {
        return request._post('/shop/product.category/image', data);
    },
     /*商品设置*/
  settingDetail(data) {
    return request._get('/shop/product.setting/index', data);
  },
  /*保存商品设置*/
  editSetting(data) {
    return request._post('/shop/product.setting/index', data);
  },
  /*批量上架操作*/
  batchProduct(data) {
    return request._post('/shop/product.product/batchShelvesProduct', data);
  },
  /*批量下架操作*/
  batch_UnshelveProduct(data) {
    return request._post('/shop/product.product/batchUnShelvesProduct', data);
  },


    /*品牌管理*/
    brandList(data) {
      return request._post('/shop/product.brand/index', data);
    },
    /*品牌列表*/
    brandList2(data) {
      return request._post('/shop/product.brand/list', data);
    },
    /*品牌添加*/
    brandAdd(data) {
      return request._post('/shop/product.brand/add', data);
    },
    /*品牌删除*/
    brandDel(data) {
      return request._post('/shop/product.brand/delete', data);
    },
    /*品牌修改*/
    brandEdit(data) {
      return request._post('/shop/product.brand/edit', data);
    },
    /*得到品牌图片*/
    cateImage1(data) {
        return request._post('/shop/product.brand/image', data);
    },

    // 批量修改商品库存
    batchStock(data) {
        return request._post('/shop/product.product/batchStock', data);
    },
    // 批量修改直推收益
    batchIncome(data) {
        return request._post('/shop/product.product/batchIncome', data);
    },
    // 批量删除商品
    batchDel(data) {
        return request._post('/shop/product.product/batchDel', data);
    },
    // 批量审核商品
    batchAudit(data) {
        return request._post('/shop/product.product/batchAudit', data);
    },
    // 批量删除商品
    batchCategory(data) {
        return request._post('/shop/product.product/batchCategory', data);
    },
    // 批量删除商品
    batchBrand(data) {
        return request._post('/shop/product.product/batchBrand', data);
    },
    // 批量更改运费模板
    batchDelivery(data) {
        return request._post('/shop/product.product/batchDelivery', data);
    },
    /*回收站管理*/
    recycleList(data) {
      return request._post('/shop/product.product/recycleIndex', data);
    },
    // 恢复商品
    recGoods(data) {
        return request._post('/shop/product.product/recycle', data);
    },
    // 添加商品属性模板
    addAttrTemplate(data) {
        return request._post('/shop/product.Attribute/add', data);
    },
    // 商品属性模板
    attrTemList(data){
        return request._get('/shop/product.Attribute/index', data);
    },
    // 删除商品属性模板
    attrDel(data){
        return request._get('/shop/product.Attribute/delete', data);
    },
    // 获取商品属性模板
    getAttrData(data){
        return request._get('/shop/data.Attribute/getAttrData', data);
    },
    // 获取商品属性值
    getAttrDataById(data){
        return request._get('/shop/data.Attribute/getAttrDataById', data);
    },
    // 获取属性模板
    getAttrEditData(data){
        return request._get('/shop/product.Attribute/getAttrEditData', data);
    },
    /* sku管理 */
    skuList(data){
        return request._get('/shop/product.sku/list',data);
    },
     /* sku折扣价格管理 */
    editSku(data){
        return request._get('/shop/product.sku/edit',data);
    },
    /* sku增加子产品 */
    addSkuChildProduct(data){
        return request._post('/shop/product.sku/addSkuChildProduct',data);
    },
    // 获取子产品
    getSkuChildProduct(data){
        return request._post('/shop/product.sku/getSkuChildProduct',data);
    },
     /* 公共组件获取sku列表 */
    getSKuProduct(data){
        return request._get('/shop/product.sku/getSKuProduct',data);
    },
    
}

export default ProductApi;



// WEBPACK FOOTER //
// ./src/api/product.js